import * as React from 'react';

export interface AuthMode {
  /** True when the SPA bootstrapped a real MSAL PublicClientApplication. */
  enabled: boolean;
}

const AuthModeContext = React.createContext<AuthMode>({ enabled: false });

export function AuthModeProvider({
  enabled,
  children
}: {
  enabled: boolean;
  children: React.ReactNode;
}) {
  const value = React.useMemo(() => ({ enabled }), [enabled]);
  return <AuthModeContext.Provider value={value}>{children}</AuthModeContext.Provider>;
}

export function useAuthMode(): AuthMode {
  return React.useContext(AuthModeContext);
}
